import React from 'react';
import { useParams } from 'react-router-dom';
import { v as bvVar } from 'bv';

import { Competitions } from 'Index/features/routing/components/main_routes/lazy_components';
import BackboneMeetings from '../backbone_meetings';

const SportEventPathIdsWithNewCompetitions = bvVar('SportEventPathIdsWithNewCompetitions');

const sportSupported = (sportId) => (
  SportEventPathIdsWithNewCompetitions.includes(parseInt(sportId, 10))
);

export default () => {
  const { sportId } = useParams();

  if (sportSupported(sportId)) {
    return <Competitions />;
  }

  return <BackboneMeetings />;
};
